import React from 'react';
import Conditional from '../../../common/conditional';
import CustomSection from '../../custom-general/custom-section';
import Image from '../../../blocks/report-image/image';

import { getOptimizedImageURL, preventImageCaching } from '../../../../utils/utilities';
import { PDFImageProps } from '../../../../utils/models';

import classNames from './style.module.scss';

interface IsometricDrawingProps {
	isoImages: PDFImageProps[];
	label: string;
	subLabel?: string;
}

const IsometricDrawing: React.FC<IsometricDrawingProps> = ({ isoImages, label, subLabel }) => {
	return (
		<>
			{isoImages.map((isoImage) => (
				<CustomSection key={isoImage.refNo} sectionTitle={label} sectionSubtitle={subLabel}>
					<div className={classNames.isoDrawing}>
						<Image
							src={preventImageCaching(getOptimizedImageURL(isoImage.src))}
							alt={isoImage.caption}
						/>
						<Conditional isVisible={false}>
							<div className={classNames.isoDrawingCaption}>{isoImage.caption}</div>
						</Conditional>
					</div>
				</CustomSection>
			))}
		</>
	);
};

export default IsometricDrawing;
